/* @ngInject */
function HomeTasksItemController () {
}

export { HomeTasksItemController }
